import React from "react";
import { MultiStepEditSection } from "components/MainSectionTemplate/MultiStepEditSectionTemplate";
import { ExternalCalendarFormState, NewExternalCalendarStep } from "./model";
import ArtistModalPicker from "components/Picker/ArtistPicker/ArtistModalPicker";
import WebsiteLink from "components/Website/WebsiteLink";

export const externalCalendarConfigureSection = (
  externalCalendarFormState: ExternalCalendarFormState,
  setExternalCalendarFormState: (state: ExternalCalendarFormState) => void,
): MultiStepEditSection<NewExternalCalendarStep> => ({
  getNextSection: () => null,
  getPrevSection: () => "externalCalendarConnect",
  isLastStep: () => true,
  sectionSteps: [{
    title: RESX.ConnectedAccount.Connect,
    isActive: false,
  }, {
    title: RESX.GeneralLabels.Configure,
    isActive: true,
  }],
  section: {
    type: "regular",
    key: "externalCalendarConfigure",
    title: RESX.ExternalCalendar.NewExternalCalendar,
    fields: [{
      key: "type",
      label: RESX.GeneralLabels.Type,
      renderEditNew: () => <div className="main-section-template-fields-padding">
        External iCalendar
      </div>,
    }, {
      key: "name",
      label: RESX.GeneralLabels.Name,
      renderEditNew: () => <div className="main-section-template-fields-padding">
        {externalCalendarFormState.name}
      </div>,
    }, {
      key: "iCalendarUrl",
      label: RESX.ExternalCalendar.iCalendarUrl,
      renderEditNew: () => <div className="main-section-template-fields-padding">
        <WebsiteLink website={externalCalendarFormState.iCalendarUrl} />
      </div>,
    }, {
      key: "eventCount",
      label: RESX.ExternalCalendar.ExternalEvents,
      renderEditNew: () => <div className="main-section-template-fields-padding">
        <div>{externalCalendarFormState.eventCount}</div>
        <div className="s1_small s1_gray">
          {RESX.ExternalCalendar.AppoinmentsFurtherInTheFutureThanXMonthsAreDiscarded.replace("{0}", serverReference.constants.externalCalendar.defaultMonthsInFuture.toString())}
        </div>
        <div className="s1_small s1_gray">
          {RESX.ExternalCalendar.AppointmentsOlderThanXMonthsAreDiscarded.replace("{0}", serverReference.constants.externalCalendar.defaultMonthsInPast.toString())}
        </div>
      </div>,
    }, {
      key: "artist",
      label: site.currentEnvironment.functionGroups.artist.singular,
      renderEditNew: () => <div className="main-section-template-fields-padding">
        <ArtistModalPicker
          canCreateNew={false}
          securityScope="limitByUserAccess"
          nonInPageEditing={{
            onChange: a => setExternalCalendarFormState({ ...externalCalendarFormState, artist: a }),
            value: externalCalendarFormState.artist,
            required: true,
            validatorKey: "artist",
          }}
        />
      </div>
    }]
  }
});